// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__MfayH","notes":"Notes_notes__3P84i"};